// 抽選キャンペーンの規約で使う窓口・賞品まわりの定数.
// 再予約側 (LotteryTermsSection) と請求側 (CancelFeeLotteryTermsSection) で同じ事務局・同じギフトを使うので共有する.
export const CAMPAIGN_OFFICE_EMAIL = "point-campaign@souhl.co.jp"
export const ANYGIFT_TERMS_URL = "https://business.anygift.jp/terms"
export const ANYGIFT_SUPPORT_EMAIL = "anygift-business@anymindgroup.com"

// 賞品 (えらべるマネー) の交換先の例. 規約の文面どおりの順で出す.
export const EXCHANGE_BRAND_EXAMPLES = [
	"PayPayポイント",
	"au PAY ギフトカード",
	"Uber Eats ギフトカード",
	"Google Play ギフトコード",
	"Amazonギフトカード",
	"Apple Gift Card",
	"Vポイント",
	"dポイント",
	"nanacoポイント",
	"電子マネーWAONポイント",
	"Visa eギフト",
	"QUOカードPay",
	"Kyash",
	"図書カードNEXT ネットギフト",
	"その他デジタルギフト",
]
